import React, { Component } from 'react'
import * as Sections from './sections'

class DynamicSection extends Component {
  constructor(props) {
    super(props)
  }

  render (){
    let InputType = Sections[this.props.sectionName];
    return <InputType onIncludeClick={() => this.props.onIncludeClick()} included={this.props.included} staticVersion={this.props.staticVersion} />;
  }
}

export default DynamicSection;



// WEBPACK FOOTER //
// ./styleguide/components/DynamicSection.js